import React, { useEffect, useState } from "react";
import {
  Alert,
  Autocomplete,
  Button,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { read } from "./api";

export default function SegmentPicker({
  api,
  entity = "segments",
  label = "Segments",
  kind,
  value,
  onChange,
  disabled = false,
  multiple = true,
}) {
  const [search, setSearch] = useState("");
  const [items, setItems] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [error, setError] = useState("");
  useEffect(() => {
    setPage(1);
    setItems([]);
  }, [search, kind, entity]);
  useEffect(() => {
    let active = true;
    const timer = setTimeout(
      () =>
        read(api, entity, { search, kind, page })
          .then((result) => {
            if (active) {
              setItems((current) =>
                page === 1 ? result.items : [...current, ...result.items],
              );
              setTotal(result.total);
              setError("");
            }
          })
          .catch((err) => active && setError(err.message)),
      250,
    );
    return () => {
      active = false;
      clearTimeout(timer);
    };
  }, [api, kind, search, page, entity]);
  const options = [
    ...value,
    ...items.filter(
      (item) => !value.some((selected) => selected.id === item.id),
    ),
  ];
  return (
    <Stack spacing={1}>
      <Autocomplete
        multiple={multiple}
        disabled={disabled}
        options={options}
        value={multiple ? value : value[0] || null}
        filterOptions={(items) => items}
        isOptionEqualToValue={(a, b) => a.id === b.id}
        getOptionLabel={(item) => item.name}
        renderOption={(props, option) => {
          const { key, ...optionProps } = props;
          return (
            <li key={key} {...optionProps}>
              <Stack
                spacing={0.5}
                sx={{ minWidth: 0, py: 0.5, overflowWrap: "anywhere" }}
              >
                <Typography fontWeight={600}>{option.name}</Typography>
                {option.description && (
                  <Typography variant="body2" color="text.secondary">
                    {option.description}
                  </Typography>
                )}
                {option.memberCount != null && (
                  <Typography variant="body2" color="text.secondary">
                    {option.memberCount} members ·{" "}
                    {option.automatic ? "Automatic" : "Custom"} ·{" "}
                    {option.kind === "contact" ? "Outreach contacts" : "Users"}
                  </Typography>
                )}
              </Stack>
            </li>
          );
        }}
        onChange={(_, selected) =>
          onChange(multiple ? selected : selected ? [selected] : [])
        }
        onInputChange={(_, text, reason) => {
          if (["input", "clear"].includes(reason)) setSearch(text);
        }}
        renderInput={(params) => <TextField {...params} label={label} />}
      />
      {items.length < total && (
        <Button onClick={() => setPage(page + 1)}>Load more</Button>
      )}
      {error && <Alert severity="error">{error}</Alert>}
    </Stack>
  );
}
